var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebDesign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 46,
    viewBox: "0 0 38 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 1V3",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 12V19.5",
    stroke: "white",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 38V43C14 44.1046 14.8954 45 16 45H22C23.1046 45 24 44.1046 24 43V38",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 41H24",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9997 38H13.4997C13.4997 38 11.4997 38 11.4997 36.5C11.4997 35 11.8435 34.4222 11.4997 32.5C10.8215 28.7091 7.50008 26.5 6.4997 23C4.16 14.8143 10.9923 5.17797 19.4997 5.50005C27.7803 5.81354 34.1197 15.1386 31.4997 23C30 27.5 26.4346 30.2068 25.9997 32.5C25.6359 34.4185 25.9997 35 25.9997 36.5C25.9997 38 23.9997 38 23.9997 38Z",
    stroke: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 38V25.7C22.5 25.5895 22.4105 25.5 22.3 25.5H15.7C15.5895 25.5 15.5 25.5895 15.5 25.7V35.5",
    stroke: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16 26V23H22V26",
    stroke: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6242 18.6269C15.1381 20.2076 15.8377 22.1885 16 23H22C22 21.4756 23.513 19.5275 24.3766 18.6261C24.4467 18.553 24.4529 18.4401 24.3904 18.3605L19.1573 11.7002C19.0772 11.5982 18.9228 11.5982 18.8427 11.7002L13.6096 18.3605C13.5471 18.4401 13.5542 18.5538 13.6242 18.6269Z",
    stroke: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 28.5H22.5",
    stroke: "white",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 32L8 30.5",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 32L30 30.5",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1 19H3",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35 19H37",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6L7.5 7.5",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 6L30 7.5",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebDesign);
export default __webpack_public_path__ + "static/media/web-design.bb1fd4141bae78b8a4d3fe027c90435f.svg";
export { ForwardRef as ReactComponent };